import { connect } from 'react-redux';

import { liveCheckTripAction } from 'wanderu-ducks-live-check';
import { tripSelectors } from 'wanderu-ducks-trips';

import Price from '../../components/SearchResult/Price/Price';

function mapStateToProps(state, ownProps) {
    const {
        seats,
        selectedFare,
        showTotalPrice,
        tripId,
        wheelchairs,
    } = ownProps;

    const { pricing } = tripSelectors.selectTripPrices(
        state,
        tripId,
        seats,
        wheelchairs,
        showTotalPrice
    );

    const lcParams = {
        seats,
        selectedFare,
        tripId,
        wheelchairs,
    };

    return {
        liveChecksInProgress: liveCheckTripAction.selectWorking(state, lcParams),
        pricing,
        tripId,
    };
}

export { Price };
export default connect(mapStateToProps)(Price);
